import { Component, NgZone, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from './services/auth.service';
import { TokenStorageService } from './services/token-storage.service';
import { FocusCleanupService } from './services/focus-cleanup.service';

@Component({
    selector: 'twolabs-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit {
  private authService = inject(AuthService);
  private tokenStorageService = inject(TokenStorageService);
  private router = inject(Router);
  private zone = inject(NgZone);
  private focusCleanupService = inject(FocusCleanupService);

  title = 'TwoLabs';
  isLoggedIn = false;

  async ngOnInit() {
    this.isLoggedIn = !!this.tokenStorageService.getToken();
    if (this.isLoggedIn) {
      await this.authService.getCurrentUser();
    } else {
      this.zone.run(() => {
        this.authService.clearCurrentUser();
        this.router.navigate(['login']);
      });
    }
  }
}
